import styled, { createGlobalStyle } from 'styled-components'
import { Row } from 'react-bootstrap'

/** Clase para `labelClassName` de RichTextInput en el formulario de curso. */
export const COURSE_FIELD_LABEL_CLASS = 'course-form-field-label'

export const CourseFormFieldStyles = createGlobalStyle`
  .${COURSE_FIELD_LABEL_CLASS} {
    margin-bottom: 0 !important;
  }
`

export const Subtitle = styled.div`
  color: #202020bf;
  font-family: Roboto;
`

export const RequiresApproval = styled.div`
  margin-top: 16px;
  padding: 16px 24px;
  font-family: Roboto;
  background-color: #f5f5f5;
  border-radius: 8px;
  > span {
    color: #363636;
    font-weight: 500;
    font-size: 14px;
  }
  .ant-switch {
    margin-top: 1px;
    float: right;
  }
`

export const Wrapper = styled.div`
  padding-top: 16px;
  > .row {
    margin: 0;
  }
  > .row + .row {
    position: initial;
    button {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`

export const CourseFormField = styled.div`
  margin-bottom: 16px;
`

export const CourseImagesSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
`

export const CourseImagesHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`

export const CourseImagesTitle = styled.h3`
  margin: 0;
  color: #002a6d;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

export const CourseImagesInfoIcon = styled.span`
  display: inline-flex;
  margin-top: 4px;
  color: #757575;

  svg {
    width: 12px;
    height: 12px;
    font-size: 12px;
  }
`

export const CourseImagesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const NormativeCertificateAlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`

/** Alineado con título/descripcion de radios (`custom-control` padding-left: 1.5rem). */
export const ClosedCourseRequestAlertWrapper = styled.div`
  margin-top: 12px;
  margin-left: 1.5rem;
  margin-bottom: 0;
`

export const ActionButtonsRow = styled(Row)`
  padding-top: 1.5rem;
  position: absolute;
  bottom: 0;
  width: 100%;
`
